import { GET_SEARCH_RESULT_SUCCESS,GET_SEARCH_RESULT_FAILURE } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posSearchResult = (state = initialState, action) => {
    switch (action.type) {
        
        case GET_SEARCH_RESULT_SUCCESS:
            return {
                data: action.payload
            }
        case GET_SEARCH_RESULT_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}